howspace.workspace.create = (() => {
    'use strict';

    const checkCreateButtonEnabled = modal => {
        let disabled = false;
        if (modal.find('input.workspace-name').length > 0 && modal.find('input.workspace-name').val().trim() === '') {
            disabled = true;
        }

        if (modal.find('input.workspace-domain').length > 0 && modal.find('input.workspace-domain').val().trim() === '') {
            disabled = true;
        }

        if (modal.data('use-cases-required')
            && modal.find('input[name="use_cases[]"]').length > 0
            && modal.find('input[name="use_cases[]"]:checked').length === 0) {
            disabled = true;
        }

        modal.find('.modal-footer .btn-success').prop('disabled', disabled);
    };

    const hasDomainError = response => {
        let hasDomainError = false;
        real.ajax.loopErrors(response, (error) => {
            if (error.property === 'workspace_domain') {
                hasDomainError = true;
            }
        });
        return hasDomainError;
    };

    const getRandomWorkspaceName = () => {
        if (typeof howspace.generateRandomWorkspaceName === 'function') {
            return howspace.generateRandomWorkspaceName();
        }

        if (typeof howspace.generateRandomName === 'function') {
            return howspace.generateRandomName();
        }

        return `workspace-${Date.now()}`;
    };

    const initWorkspaceInfoHandlers = (modal) => {
        modal.on('click', '.randomize-workspace-name-btn', () => {
            modal.find('input.workspace-name').val(getRandomWorkspaceName()).trigger('input');
        });

        modal.on('input', 'input.workspace-name', e => {
            const domainInput = modal.find('input.workspace-domain');
            if (domainInput.length === 0) {
                return;
            }

            const workspaceName = $(e.currentTarget).val();

            domainInput.val(workspaceName);
            domainInput.removeClass('is-invalid');
            real.input.validateWorkspaceDomainLocal.call(domainInput[0]);
            domainInput.val(domainInput.val().substring(0, 56));
            real.input.validateWorkspaceDomainLocalBlur.call(domainInput[0]);
            real.input.validateWorkspaceDomain(
                modal,
                () => { checkCreateButtonEnabled(modal); }
            );
        });

        modal.on('input', 'input.workspace-domain', () => {
            real.input.validateWorkspaceDomain(
                modal,
                () => { checkCreateButtonEnabled(modal); }
            );
        });

        modal.on('keyup', 'input.workspace-name, input.workspace-domain', function (e) {
            if (e.keyCode === 13) {
                modal.find('.preview-btn, .create-button:visible').trigger('click');
            }
        });

        modal.find('.workspace-domain').on('input', function () {
            $(this).removeClass('is-invalid');
        });

        modal.find('.workspace-domain').on('input', real.input.validateWorkspaceDomainLocal);
        modal.find('.workspace-domain').on('blur', real.input.validateWorkspaceDomainLocalBlur);

        modal.on('input', 'input.workspace-name, input.workspace-domain', () => { checkCreateButtonEnabled(modal); });


        if (modal.data('use-cases-required')) {
            modal.on('change', 'input[name="use_cases[]"]', () => { checkCreateButtonEnabled(modal); });
        }
    }

    const initModal = (modal, modalOpener, redirectToWorkspace = true) => {
        modal = $(modal);

        howspace.securitySettings.init(modal);
        howspace.workspace.settings.initEmailDeliverySchedule();
        howspace.workspace.settings.initImmediateEmailToggle(modal);

        howspace.workspace.create.initWorkspaceInfoHandlers(modal);
        howspace.workspace.settings.attachLoginHandlers(modal);

        modal.on('click', '.create-workspace-btn:not(.disabled)', function () {
            const btn = $(this);

            real.button.loading(btn, modal.find('.modal-body'));

            const dataPayload = howspace.workspace.settings.getSettingsPayload(modal, false);
            dataPayload.workspace_domain = $.trim(modal.find('input.workspace-domain').val()) + modal.find('.workspace-root-domain').text();

            let url = real.baseUri + '/api/workspaces';
            if (modal.data('api-url')) {
                url = modal.data('api-url');
            }

            real.ajax.json(url, {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    if (redirectToWorkspace) {
                        real.events.on('workspace:ready', (notification) => {
                            window.location = notification.object.loginlink.url;
                        });
                    } else {
                        howspace.components.modal.close(modal);
                        howspace.dispatchEvent(modalOpener, howspace.workspace.create.WORKSPACE_CREATED);
                    }
                },
                logError: response => {
                    return !howspace.workspace.create.hasDomainError(response);
                },
                showErrorNotification: response => {
                    return !howspace.workspace.create.hasDomainError(response);
                },
                error: response => {
                    real.button.reset(btn, modal.find('.modal-body'));
                    if (howspace.workspace.create.hasDomainError(response)) {
                        const domainInput = modal.find('.workspace-domain');
                        howspace.form.markInvalidField(domainInput);
                        requestAnimationFrame(() => {
                            real.input.focus(domainInput);
                        });
                    }
                }
            });
        });
    };

    const initSelectWorkspaceTemplateModal = (modal) => {
        modal = $(modal);

        // The filter checkboxes and search input live outside the lister element (matching My Howspace's
        // own template picker), so the lister's own automatic form-scraping (which only looks at its own
        // descendants) never sees them. Same fix as My Howspace's: rebuild the query from the filters
        // wrapper, bake it into the lister's data-uri, then reload.
        const reloadWithFilters = () => {
            const lister = modal.find('.howspace-lister');
            const dataPayload = real.form.getDataPayload(modal.find('.templates-filter'));
            dataPayload.search = String(modal.find('.search-input').val() || '').trim();

            const baseUri = lister.data('uri').split('?')[0];
            lister.dataAndAttr('uri', baseUri + '?' + $.param(dataPayload));
            howspace.components.lister.reload(lister);
        };

        modal.on('change', '.templates-filter input', reloadWithFilters);
        modal.find('.search-input').on(howspace.components.searchInput.SEARCH, reloadWithFilters);

        // The picker's cards have no separate "use template" button, the whole card is the click target
        // (matching My Howspace's own template picker), so this modal-open call can't be attached through
        // the generic ModalSettings/data-modal mechanism the way a button-driven action would be.
        modal.on('click', '.workspace-templates-picker-card', e => {
            if (e.target.closest('.howspace-menu') !== null) {
                return;
            }

            const workspaceId = e.currentTarget.dataset.workspaceId;
            howspace.components.modal.show(
                `${real.baseUri}/manager/workspace-templates/${workspaceId}/create-workspace-modal?from_picker=1`,
                modal => howspace.workspace.create.initCreateFromTemplateModal(modal, modal)
            );
        });

        real.events.on('workspace:poster-image:updated', function (notification) {
            const workspaceId = notification.object.workspace.id;
            const posterImage = notification.object.workspace.poster_image;
            const picture = $('.workspace-template-card[data-workspace-id="' + workspaceId + '"] .workspace-cover-picture')[0];

            if (!picture) {
                return;
            }

            // Replace the cover picture with the new picture.
            howspace.components.picture.replacePicture(
                picture,
                posterImage.id,
                posterImage.href,
                posterImage.metadata
            );
        });
    };

    const initCreateFromTemplateModal = (modal, modalOpener) => {
        modal = $(modal);

        let workspaceId = modal.data('workspace-template-id');

        howspace.workspace.create.initWorkspaceInfoHandlers(modal);

        const createBtn = modal.find('.create-workspace-btn');
        createBtn.on('click', () => {
            const dataPayload = real.form.getDataPayload(modal);
            dataPayload.workspace_domain = $.trim(modal.find('input.workspace-domain').val()) + modal.find('.workspace-root-domain').text();
            dataPayload.new_duplication = true;
            dataPayload.include_default_emails = true;
            dataPayload.include_email_batches = true;
            dataPayload.users_scope = modal.data('users-scope') ?? 'acting_user';

            if (modal.find('#workspace-template').length > 0) {
                workspaceId = modal.find('#workspace-template').val();
            }

            const options = {
                btn: createBtn,
                modal: modal,
                modalOpener: modalOpener,
                workspaceId: workspaceId,
                dataPayload: dataPayload,
            };
            howspace.workspace.duplicate.run(options);
        });
    };

    // Blank/template/duplicate cards carry their next-step url/init in a data-use-case-modal attribute (same
    // shape ModalSettings produces for buttons, kept under its own attribute name so this delegated handler is
    // the only thing reading it, distinct from the generic data-modal click handler in howspace.components.modal
    // which only matches its exact click target). My Howspace wires the draft/AI Builder cards itself on top
    // of this, they are not present outside My Howspace.
    const initSelectionModal = (modal) => {
        modal = $(modal);
        modal.find('.modal-footer').addClass('d-none');

        modal.on('click', '.use-case[data-use-case-modal]:not(.disabled)', e => {
            const settings = $(e.currentTarget).data('use-case-modal');
            if (!settings || !settings.url) {
                return;
            }

            const initFn = settings.init ? howspace.components.getCallback(settings.init) : null;
            howspace.components.modal.show(settings.url, initFn);
        });

        // An AI Builder tile with something to ask first carries that modal and goes through the handler above.
        // Without one there is nothing to ask, so the tile creates the workspace itself.
        modal.on('click', '.use-case[data-use-case="ai_builder"]:not([data-use-case-modal])', e => {
            howspace.workspace.aiBuilder.create(modal, $(e.currentTarget));
        });
    };

    return {
        WORKSPACE_CREATED: 'howspace-workspace-created',
        initModal: initModal,
        initSelectionModal: initSelectionModal,
        initSelectWorkspaceTemplateModal: initSelectWorkspaceTemplateModal,
        initCreateFromTemplateModal: initCreateFromTemplateModal,
        initWorkspaceInfoHandlers: initWorkspaceInfoHandlers,
        hasDomainError: hasDomainError,
    };
})();
